import React, { useState } from "react";
import {
  Popover,
  Icon,
  Typography,
  CircularLoader,
  Modal,
  Button,
  DatePicker,
  RadioGroup,
  Radio,
  Tooltip,
} from "@plum-xoxo/admin-dsm";
import StyledChip from "../../../../../components/styled/Chip";
import moment from "moment";
import { isFilterApplied } from "../../utils";

const getCustomIcon = () => {
  return <Icon iconName="PlumCalendar" color="dark" shade="c200" size="s" />;
};

const DownloadReports = ({
  columns,
  downloadReport,
  preparingToDownload = false,
  count = 0,
  loading,
  maxDownloadRows,
  employee_email,
  chipProps = {},
  hideReportOptions,
  type,
  title,
  kyb_status,
}) => {
  const [showEmailConfirmationPopup, setShowEmailConfirmationPopup] =
    useState(false);
  const [selected, setSelected] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isRangeDownload, setIsRangeDownload] = useState(false);

  const startDateIsOutsideRange = (date) => {
    if (endDate) {
      if (endDate < date) {
        return true;
      }
    }
    if (moment(date) > new Date()) {
      return true;
    }
    return false;
  };

  const endDateIsOutsideRange = (date) => {
    if (startDate) {
      if (startDate > date) {
        return true;
      }
    }
    if (moment(date) > new Date()) {
      return true;
    }
    return false;
  };

  const handleDownload = () => {
    const filters = {
      is_historical: 1,
    };
    if (isRangeDownload) {
      const dateFormat = "YYYY-MM-DD";
      if (title === "reward code" || title === "reward points") {
        filters.generation_start_date = moment(startDate).format(dateFormat);
        filters.generation_end_date = moment(endDate).format(dateFormat);
      } else {
        filters.start_date = moment(startDate).format(dateFormat);
        filters.end_date = moment(endDate).format(dateFormat);
      }
    }
    downloadReport(filters);
    setShowPopup(false);
  };

  return (
    <div>
      <Popover
        width={284}
        onVisibilityChange={(data) => {
          setSelected(data);
        }}
        content={
          <>
            <Tooltip
              tooltip={
                kyb_status == 6 || kyb_status == 7
                  ? "Reactivate your account to make any changes."
                  : null
              }
              offset={[-100, -30]}
            >
            {title !== "gift cards" && (
              <Popover.Options disabled={kyb_status == 6 || kyb_status == 7}>
                <div
                  className="d-flex align-items-center justify-content-between"
                  onClick={() => {
                    if (kyb_status == 6 || kyb_status == 7) return;
                    if (maxDownloadRows && maxDownloadRows < count) {
                      setShowEmailConfirmationPopup(true);
                      document.body.click();
                    } else {
                      downloadReport({}, true);
                    }
                  }}
                >
                  <Typography color="text" shade="c04" className="mb-0">
                    {type === "xoxo_token_report"
                      ? "Last 12 months record"
                      : "Download"}
                  </Typography>
                  {preparingToDownload === "last12month" ? (
                    <CircularLoader size="xs" color="base" />
                  ) : null}
                </div>
              </Popover.Options>
            )}
              {isFilterApplied(columns) && !loading && !hideReportOptions && (
                <Popover.Options disabled={kyb_status == 6 || kyb_status == 7}>
                  <div
                    className="d-flex align-items-center justify-content-between"
                    onClick={() => {
                      if (kyb_status == 6 || kyb_status == 7) return;
                      if (maxDownloadRows && maxDownloadRows < count) {
                        setShowEmailConfirmationPopup(true);
                        document.body.click();
                      } else {
                        downloadReport();
                      }
                    }}
                  >
                    <Typography color="text" shade="c04" className="mb-0">
                      Filtered records
                    </Typography>
                    {preparingToDownload === "filtered" ? (
                      <CircularLoader size="xs" color="base" />
                    ) : null}
                  </div>
                </Popover.Options>
              )}

              {type === "xoxo_token_report" && (
                <Popover.Options
                  disabled={kyb_status == 6 || kyb_status == 7}
                  onClick={() => {
                    if (kyb_status == 6 || kyb_status == 7) return;
                    document.body.click();
                    setShowPopup(true);
                  }}
                >
                  <Typography
                    color="text"
                    shade="c04"
                    className="mb-0"
                    id="reports-download-historical-record-btn"
                  >
                    Historical records
                  </Typography>
                </Popover.Options>
              )}
            </Tooltip>
          </>
        }
        offset={[0, 16]}
        placement="bottom-end"
      >
        <StyledChip
          {...chipProps[selected ? "active" : "unactive"]}
          label="Download"
          textColor="dark"
          textShade="c300"
          size="medium"
          className="ml-12 pl-8"
          zIndex={-1}
          onOverlayClick={() => {
            return;
          }}
          id="reports-download-btn"
          avatar={
            <div className="pl-2">
              <Icon iconName="Download" className="mt-6" size={16} />
            </div>
          }
        />
      </Popover>
      <Modal
        isOpen={showEmailConfirmationPopup}
        onClose={() => {
          setShowEmailConfirmationPopup(false);
        }}
        disableCloseButton={false}
        timeout={0}
        className="d-flex justify-content-center align-items-center"
      >
        <div>
          <Typography.H2>Send report to email</Typography.H2>
          <Typography className="mt-12">
            As the number of records is more than {maxDownloadRows}, the report
            will be sent to the email ID {employee_email}. Do you want to
            proceed?
          </Typography>
          <div className="d-flex justify-content-end">
            <Button
              color="primary"
              variant="fill"
              onClick={() => {
                downloadReport();
                setShowEmailConfirmationPopup(false);
              }}
            >
              Ok
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={showPopup}
        onClose={() => {
          setShowPopup(false);
        }}
        disableCloseButton={false}
        size="md"
        style={{ width: "476px" }}
      >
        <Typography.H2 color="dark" shade="c300">
          Download Historical Reports
        </Typography.H2>
        <Typography color="dark" shade="c200">
          The records will be emailed to {employee_email}.
        </Typography>
        <RadioGroup direction="column" className="mt-20">
          <Radio
            label="Download all available records"
            name="a"
            className="mb-24"
            checked={!isRangeDownload}
            onChange={() => {
              setIsRangeDownload(false);
            }}
          />
          <Radio
            label="Download records between"
            name="a"
            checked={isRangeDownload}
            onChange={() => {
              setIsRangeDownload(true);
            }}
          />
        </RadioGroup>
        <div className="d-flex ml-16 pl-24 mb-20">
          <div className="mr-16">
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={startDate}
              onChange={(value) => {
                setStartDate(value);
              }}
              shouldDisableDate={(day) => startDateIsOutsideRange(day)}
              defaultCalendarMonth={endDate ? new Date(endDate) : new Date()}
              disabled={!isRangeDownload}
              components={{
                OpenPickerIcon: getCustomIcon,
              }}
              placeholder="Start date"
            />
          </div>
          <div>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={endDate}
              onChange={(value) => {
                setEndDate(value);
              }}
              shouldDisableDate={(day) => endDateIsOutsideRange(day)}
              defaultCalendarMonth={endDate ? new Date(endDate) : new Date()}
              disabled={!isRangeDownload}
              components={{
                OpenPickerIcon: getCustomIcon,
              }}
              placeholder="End Date"
            />
          </div>
        </div>
        <div className="d-flex">
          <Button
            color="primary"
            variant="plain"
            className="mr-12 ml-auto"
            onClick={() => {
              setShowPopup(false);
              setEndDate(null);
              setStartDate(null);
              setIsRangeDownload(0);
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="fill"
            disabled={
              !isRangeDownload ? false : startDate && endDate ? false : true
            }
            onClick={handleDownload}
          >
            Download
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DownloadReports;
